const positions = {
  '---NONE---': '',
  'Abteilungsleitung':	'237',
  'Allgemein / Sonstiges':	'236',
  'EDI Management':	'234',
  'Verkauf':	'232',
  'Logistik':	'233',
  'Marketing':	'231',
  'Geschäftsleitung Assistenz':	'203',
  'Ausgeschieden':	'246',
  'Buchhaltung':	'243',
  'Chefredakteur*in':	'ChefRedakteur*in',
  'Content Management':	'245',
  'Deputy Redakteur*in':	'Deputy Redakteur*in',
  'Einkauf':	'201',
  'Filialleitung':	'238',
  'Fotoredaktion':	'Fotoredaktion',
  'freie/r Redakteur*in':	'freier Redakteur',
  'Geschäftsadresse:/Store-Address':	'506',
  'Geschäftsführung':	'235',
  'Herausgeber':	'Herausgeber',
  'Inhaber':	'230',
  'Merchandise':	'241',
  'Presse CH': 'Presse CH',
  'Redakteur Lifestyle & Mode': 'Redakteur Lifestyle & Mode',
  'Redaktionsleitung':	'Redaktionsleitung',
  'Reklamation':	'242',
  'Sportredakteur*in': 'Sportredakteur',
  'Stellv. Chefredakteur*in':	'Stellv. Chefredakteurin',
  'stellv. Leitung Mode':	'stellv. Leitung Mode',
  'Teamleitung':	'239',
  'Wirtschaftsredaktion':	'Wirtschaftsredaktion',
  'Zentraleinkauf':	'202',
  'Einkauf Assistenz':	'247',
};

const salutations = {
  'Empty': '',
  'Mr': 'Mr.',
  'Ms': 'Ms.',
  'Team': 'Team'
};

const fields = [
  'Salutation',
  'FirstName',
  'LastName',
  'Email',
  'Phone',
  'Position__c',
];

export { positions, salutations, fields };
